import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const ButtonDisabledContext = createContext(undefined);
export const ButtonDisabledContextProvider = ({ children, disabled }) => (_jsx(ButtonDisabledContext.Provider, { value: disabled, children: children }));
export const useButtonDisabledContext = () => useContext(ButtonDisabledContext);
